import { C } from '../lib/theme.ts';

/** Credits plus the legal basis the rule engine models. */
export default function Footer() {
  return (
    <div
      style={{
        padding: '14px 20px',
        fontSize: 10.5,
        lineHeight: 1.6,
        color: C.muted,
        textWrap: 'pretty',
        maxWidth: 1100,
      }}
    >
      <span
        style={{
          display: 'block',
          fontSize: 11.5,
          fontWeight: 600,
          color: C.ink,
          marginBottom: 10,
        }}
      >
        Tüm Hakları Saklıdır. — Eser Özvataf tarafından geliştirilmiştir. İletişim ve destek için{' '}
        <a href="https://x.com/eserozvataf" target="_blank" rel="noopener noreferrer">
          x.com/eserozvataf
        </a>
      </span>
      Kural setleri TFF 2026-27 Süper Lig statüsü (A Takım Listesi&apos;nde en fazla 14 yabancı; 14
      yazılması hâlinde en az 4&apos;ünün 01.01.2003 ve sonrası doğumlu olması) ile UEFA kulüp
      müsabakaları liste esaslarına (Liste A azami 25, en az 8 yetiştirilmiş oyuncu — bunların en az
      4&apos;ü kulüp altyapısı; Liste B için 2005 ve sonrası doğumlu, 15 yaşından itibaren iki yıl
      kesintisiz kulüpte bulunma) göre modellenmiştir. Oyuncu istatistikleri ve piyasa değerleri
      temsilîdir.
    </div>
  );
}
